import { BrowserRouter, Route, Routes } from "react-router-dom"
import About from "./components/about";
import Cooperative from "./components/cooperative";
import Description from "./components/description";
import Error from "./components/error";
import Footer from "./components/footer";
import Hero from "./components/hero";
import Loader from "./components/loader";
import Login from "./components/login";
import NavBar from "./components/navBar";
import NewsLetter from "./components/newsletter";
import Pods from "./components/pods";
import Save from "./components/save";
import Signup from "./components/singup";
import Tech from "./components/tech";

const App =()=>{
  return (
    <BrowserRouter>
    <Loader />
    <NavBar />
    <Routes>
        <Route exact path="/" element={<Hero/>}/>
        {/* <Route path="tech" element={<Tech/>}/> */}
        <Route path="description" element={<Description/>}/>
        <Route path="about" element={<About />}/>
        <Route path="newsletter" element={<NewsLetter/>}/>
        <Route path="save" element={<Save />} />
        <Route path="cooperative" element={<Cooperative />} />
        <Route path="pods" element={<Pods />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="*" element={<Error/>} />
      </Routes>
      <Footer/>
      </BrowserRouter>
  );
}

export default App;